<template>
  <div id="checkinCancel" class="container">
    <div class="check-tab">
      <CheckInTab :tabInit="tabInit"></CheckInTab>
    </div>
    <div class="checkin-wrap">
      <div class="step-wrap">
        <components v-bind:is="stepName" :stepData="stepData" @callback="nextStep"></components>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
#checkinCancel {
  .checkin-wrap {
    padding-top: 30px;
  }
}
@media only screen and (max-width: 768px) {
  #checkinCancel {
    .checkin-wrap {
      padding-top: 15px;
    }
  }
}
</style>
<script>
import CheckInTab from '@/components/checkin/checkInTab'
import Step1 from './components/step1'
import Step2 from './components/step2'
import './index'
export default {
  data () {
    return {
      tabInit: '3',
      stepName: 'step1',
      idInfo: {},
      stepData: {}
    }
  },
  created () {
    if (window.idInfo) {
      this.nextStep(2, window.idInfo)
    }
  },
  methods: {
    nextStep (step, data) {
      this.stepName = 'step' + step
      if (data) {
        this.stepData = data
      }
    }
  },
  components: {
    CheckInTab,
    Step1,
    Step2
  }
}
</script>
